import React, { useState } from 'react'
import AppPopover from '../ModalShell/AppPopover'
import { StyleSheet } from 'react-native'
import { useSelector } from 'react-redux'

import Button from '../../UIControls/Button'
import NotificationSettingsModal from './NotificationSettingsModal'
import { colors, em2px } from '../../styles/global'
import { translate } from '../../../i18n/TranslationService'
import { popoverToCenter } from '../../../utils/HelperFunctions'

const NotificationSettings = () => {
    const smallScreenNavigation = useSelector(state => state.smallScreenNavigation)
    const { receiveEmails, pushNotificationsStatus, receiveWhatsApp } = useSelector(state => state.loggedUser)
    const [isOpen, setIsOpen] = useState(false)

    const getTitle = () => {
        const enabled = []
        if (pushNotificationsStatus) enabled.push(translate('Push'))
        if (receiveEmails) enabled.push(translate('Email'))
        if (receiveWhatsApp) enabled.push(translate('WhatsApp'))
        return enabled.length > 0
            ? `${enabled.join(' & ')} ${translate('notifications')}`
            : translate('Notifications disabled')
    }

    return (
        <AppPopover
            isOpen={isOpen}
            onClickOutside={() => setIsOpen(false)}
            disableReposition={smallScreenNavigation}
            contentLocation={smallScreenNavigation && popoverToCenter}
            align={'center'}
            position={['left', 'bottom', 'top']}
            content={<NotificationSettingsModal setIsOpen={setIsOpen} />}
        >
            <Button
                title={getTitle()}
                type="ghost"
                onPress={() => setIsOpen(!isOpen)}
                numberTitleLines={2}
                titleStyle={localStyles.text}
                buttonStyle={{ width: 124 }}
            />
        </AppPopover>
    )
}

const localStyles = StyleSheet.create({
    text: {
        fontFamily: 'Roboto-Regular',
        fontSize: 12,
        lineHeight: 14,
        letterSpacing: em2px(0.03),
        color: colors.Text03,
        maxWidth: 142,
    },
})

export default NotificationSettings
